var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("/public/images/logos/" + _vm.name + ".png"),"alt":"Logo de La Prensa Gráfica - Grupo Dutriz"}})}
var staticRenderFns = []

export { render, staticRenderFns }